<template>
  <div>
    <div class="app-logo">
      <div class="app-logo-header sub-container">
        <div class="site-logo-logo">
          <img :src="mylogo">
        </div>
        <div class="site-slogan">
          <p>为科技工作者服务</p>
          <p>为创新驱动发展服务</p>
          <p>为提高全民科学素质服务</p>
          <p>为党和政府科学决策服务</p>
        </div>
        <div class="site-logo-search">
          <div class="site-logo-date text-right" style="margin-bottom:1rem;">{{ nowdate }}</div>
          <el-input v-model="query" size="medium" placeholder="搜索">
            <i slot="suffix" class="el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <van-sticky>
      <header class="app-header" :class="[{'ismenu': showMenu}, templateName]">
        <div class="site-nav">
          <div class="site-nav-box sub-container">
            <div class="site-bar" @click="showMenu = !showMenu">
              <i class="el-icon-more-outline"></i>
            </div>
            <div class="site-logo">
              <img :src="smalllogo">
            </div>
            <div class="site-nav-menu-wrap" ref="menu">
              <div class="site-nav-menu">
                <a href="javascript:;" :class="{active: 'home' == active}" @click="active = 'home'">
                  <i class="iconfont">&#xe64f;</i>
                </a>
                <template v-for="item in navList">
                  <a :key="item.id" href="javascript:;" :class="{active: item.id == active}">{{ item.name }}
                    <van-icon v-if="item.childList && item.childList.length" name="arrow-down" />
                    <div v-show="item.childList && item.childList.length" class="site-nav-submenu">
                      <div class="site-nav-submenu-box sub-container">
                        <template v-for="sitem in item.childList">
                          <a :key="sitem.id" href="javascript:;" :class="{active: sitem.id == active2}" @click="active2 = sitem.id">{{ sitem.name }}</a>
                        </template>
                      </div>
                    </div>
                  </a>
                </template>
              </div>
            </div>
            <!-- <div class="site-login">
              <a href="javascript:;" class="login">登录</a>
              <a href="javascript:;">注册</a>
            </div> -->
            <div class="site-search" :class="{'is-focus': isQuery}">
              <el-input v-model="query" size="small" @blur="isQuery = false" ref="query">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <i class="el-icon-search search-btn" @click="doQuery"></i>
            </div>
          </div>
        </div>
        <div v-if="showMenu" class="mobile-menu-wrap">
          <div class="mobile-menu">
            <template v-for="item in navList">
              <a :key="item.id" href="javascript:;" :class="{active: item.id == active}" @click="active = item.id" @mouseenter="active = item.id">{{ item.name }}
                <div v-if="submenus.length && active == item.id" class="mobile-submenu">
                  <template v-for="item in submenus">
                    <a :key="item.id" href="javascript:;" :class="{active: item.id == active2}" @click="active2 = item.id">{{ item.name }}</a>
                  </template>
                </div>
              </a>
            </template>
          </div>
          <div class="mobile-login">
            <a href="javascript:;" class="login">登录</a>
            <el-divider direction="vertical"></el-divider>
            <a href="javascript:;">注册</a>
          </div>
          <div class="mobile-footer">
            <div class="links">
              <a href="javascript:;">关于我们</a>
              <el-divider direction="vertical"></el-divider>
              <a href="javascript:;">招贤纳士</a>
              <el-divider direction="vertical"></el-divider>
              <a href="javascript:;">版权声明</a>
              <el-divider direction="vertical"></el-divider>
              <a href="javascript:;">投诉建议</a>
            </div>
            <div class="infos">
              <div class="address">
                <p>地址：四川省成都市人民南路四段11号</p>
                <p>邮编：610041</p>
                <p>新闻热线：028-65059827 / 65059830</p>
              </div>
              <div class="qrcode">
                <el-image src="http://www.sdkp.com.cn/images/ewm.jpg"></el-image>
              </div>
            </div>
            <div class="copyright">
              <p>Copyright © 2020 师大科培 版权所有 / 蜀ICP备17026920号-1 / 互联网新闻信息服务许可证：51120190024</p>
            </div>
          </div>
        </div>
      </header>
      <!-- <div class="set-template" :class="templateName" @click="setTemplate">
        <i class="el-icon-s-open"></i>
      </div> -->
    </van-sticky>
  </div>
</template>

<script>
// import BScroll from '@better-scroll/core';
// import ScrollBar from '@better-scroll/scroll-bar'
// BScroll.use(ScrollBar);
import { mapState } from 'vuex';
import tools from '@/utils/tools';
export default {
  name: 'AppHeader',
  mixins: [tools],
  props: [],
  data () {
    return {
      active: 'home',
      active2: '',
      scroll1: null,
      scroll2: null,
      showMenu: false,
      query: '',
      isQuery: false,
      navList: [
        // {id:'home', name:'首页'},
        {id:'zh', name:'科技头条'},
        {id:'dfbd', name:'地方报道', childList: [
          {id: 'cd', name:'成都'},
          {id: 'my', name:'绵阳'},
          {id: 'dy', name:'德阳'},
          {id: 'zg', name:'自贡'},
          {id: 'pzh', name:'攀枝花'},
          {id: 'lz', name:'泸州'},
          {id: 'gy', name:'广元'},
          {id: 'sn', name:'遂宁'},
          {id: 'nj', name:'内江'},
          {id: 'ls', name:'乐山'},
          {id: 'nc', name:'南充'},
          {id: 'yb', name:'宜宾'},
          {id: 'ga', name:'广安'},
          {id: 'dz', name:'达州'},
          {id: 'ms', name:'眉山'},
          {id: 'bz', name:'巴中'},
          {id: 'ya', name:'雅安'},
          {id: 'zy', name:'资阳'},
          {id: 'ab', name:'阿坝'},
          {id: 'gz', name:'甘孜'},
          {id: 'lis', name:'凉山'},
        ]},
        {id:'kjqy', name:'科技前沿'},
        {id:'kygz', name:'科协工作', childList: [
          {id:'xhgz', name:'学（协）会工作'},
          {id:'gzz', name:'工作站建设'},
          {id:'tfys', name:'天府院士'},
          {id:'kjrc', name:'科技人才'},
          {id:'sqkp', name:'社区科普'},
        ]},
        {id:'kydt', name:'科技动态'},
        {id:'kjfp', name:'科技扶贫', childList: [
          {id:'xdny', name:'现代农业'},
          {id:'zfj', name:'致富经'},
          {id:'mycp', name:'名优产品'},
        ]},
      ]
    }
  },
  computed: {
    ...mapState(['templateName']),
    nowdate() {
      return this.formatDate(new Date(), 'yyyy年MM月dd日 星期dddd')
    },
    submenus() {
      let list = this.navList.filter(d => this.active == d.id);
      if (list.length) {
        return list[0].childList || [];
      }
      return [];
    },
    mylogo() {
      let logo = `${this.templateName == 'light' ? '-red' : '-red'}.png`;
      return this.assetsPath +'static/images/'+ (`logo${logo}`);
      // return this.assetsPath +'static/images/'+ (this.isMobile || this.isWeixin ? `logo-small${logo}` : `logo${logo}`);
    },
    smalllogo() {
      let logo = `${this.templateName == 'light' ? '-red' : '-red'}.png`;
      return this.assetsPath +'static/images/'+ `logo-small${logo}`;
    }
  },
  mounted () {
    // this.$nextTick(() => {
    //   this.initScroll1();
    // });
  },
  methods: {
    // initScroll1() {
    //   this.bscroll = new BScroll(this.$refs.menu, {
    //     scrollbar: true,
    //     scrollX: true,
    //     scrollY: false,
    //     bounce: false,
    //     eventPassthrough: 'vertical',
    //     stopPropagation: true
    //   });
    // },
    setTemplate() {
      let name = this.templateName == 'light' ? 'dark' : 'light';
      this.$store.commit('setTemplate', name);
    },
    doQuery() {
      this.isQuery = true;
      this.$nextTick(() => this.$refs.query.focus());
    },
  }
}
</script>
<style lang="less" scoped>
// template - begin
.set-template {
  position:fixed;
  bottom:2rem;
  right:2rem;
  i {
    display:block;
    height:2rem;
    width:2rem;
    .fontsize(2rem);
    line-height:2rem;
    padding:.5rem;
    color:#fff;
    background-color:#4776e6;
    border:1px #4776e6 solid;
    border-radius:100%;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.35);
  }
  &.light {
    i {
      color:#4776e6;
      background-color:#fff;
    }
  }
}
.app-logo {
  padding:1rem 0;
  background-image: linear-gradient(to bottom, #f5f5f5, #eee);
  &-header {
    display: flex;
    justify-content: space-between;
  }
  c
  .site-slogan {
  }
  .site-logo-search {
    width:30%;
    /deep/ .el-input__inner {
      border-width:2px;
      border-color:#999;
      background-color:#f9f9f9;
      &:focus {
        border-color:#fa7a87;
      }
    }
    /deep/ .el-input__suffix {
      right:15px;
    }
    /deep/ .el-input__suffix-inner {
      .fontsize(1.2rem);
      line-height:36px;
    }
  }
}
// template - end
header.app-header {
  position:relative;
  z-index:99;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0,0,0,0.13);
  &.ismenu {
    z-index:100000;
    .flex-column();
    height:100vh;
  }
  &.dark {
    background-color:#D00010;
    // background-image: linear-gradient(to bottom, #f44, #651F15);
  }
}
.van-sticky--fixed {
  header.app-header {
    background-color: rgba(255, 255, 255, .95);
    box-shadow: 0 0 10px rgba(0,0,0,0.25);
    &.dark {
      background-color: rgba(208, 0, 16, .95);
    }
  }
  .site-nav-submenu {
    background-color:rgba(250,250,250,.95);
  }
  .site-logo {
    display:flex;
    height:100%;
    img {
      height:3rem;
    }
  }
  .site-search {
    display:flex;
  }
}
.site {
  &-nav {
    padding:0 .5rem;
    min-height:3.5rem;
    &-box {
      .flex();
    }
    &-menu-wrap{
      flex-grow:1;
      align-self: stretch;
      overflow:hidden;
      height:3.5rem;
    }
    &-menu {
      display:flex;
      justify-content:space-between;
      align-items:stretch;
      height:100%;
      a {
        padding:.25rem 1rem;
        .flex();
        flex:1;
        justify-content: center;
        align-items:center;
        .fontsize(1.24rem);
        color:#222;
        // font-weight:bold;
        border-left:1px #fb4c59 solid;
        border-right:1px #8b1922 solid;
        white-space: nowrap;
        border-bottom:3px transparent solid;
        &:first-child {
          border-left-color:transparent;
        }
        &:last-child {
          border-right-color:transparent;
        }
        .app-header.dark & {
          color:#fff;
          border-bottom:none;
        }
        &:hover, &.active {
          color: #4776e6;
          border-bottom-color:#4776e6;
          // background-color: #fff;
          // box-shadow: 0 -10px 10px 0 rgba(0,0,0,0.1);
          .site-nav-submenu {
            display:block;
          }
          .app-header.dark & {
            color:#fff;
            background-color:#FC3A49;
          }
        }
        .site-nav-submenu {
          display:none;
          a {
            border-left:none;
            border-right:none;
          }
        }
        .van-icon {
          margin-left:.2rem;
          .fontsize(1.1rem);
          color:#555;
          .app-header.dark & {
            color:#f5f5f5;
          }
        }
      }
    }
    &-submenu {
      position:absolute;
      top:100%;
      left:0;
      right:0;
      padding:.5rem;
      background-color:#f5f5f5;
      transition:all .5s;
      &-box {
        .flex();
        justify-content:center;
        flex-wrap:nowrap;
      }
      a {
        margin:0 .05rem;
        padding:.25rem 1rem;
        .flex();
        flex-grow:0;
        align-items:center;
        align-self: stretch;
        .fontsize(1.08rem);
        color:#222;
        .app-header.dark & {
          color:#222;
        }
        &:hover, &.active {
          color: #f5f5f5;
          background-color: #BE3926;
          border-radius:.5rem;
          .app-header.dark & {
            color: #f5f5f5;
            background-color: #BE3926;
          }
        }
      }
    }
  }
  &-bar {
    display:none;
    padding:0 .5rem;
    flex-shrink:0;
    align-self:stretch;
    justify-self:flex-end;
    .fontsize(1.8rem);
    color:#777;
    &:hover {
      color:#4776e6;
      background-color:#f1f1f1;
    }
  }
  &-search {
    position:relative;
    // display:flex;
    margin-left: 2rem;
    padding:0 .5rem;
    flex-shrink:0;
    align-self:stretch;
    justify-self:flex-end;
    .fontsize(1.8rem);
    color:#4776e6;
    .flex-center-v();
    display:none;
    .app-header.dark & {
      color:#fff;
    }
    /deep/ .el-input {
      position:absolute;
      right:0;
      top:50%;
      display:none;
      width:0;
      transform: translateY(-50%);
      transition: width .3s;
    }
    &.is-focus {
      width:13rem;
      i.search-btn{
        display:none;
      }
      /deep/ .el-input {
        display:block;
        width:12rem;
      }
    }
  }
  &-logo {
    .flex-center-v();
    display:none;
    margin-right:1.5rem;
    padding:.25rem 0;
    align-self: center;
    height:100%;
    img {
      height:3.5rem;
    }
    flex-shrink:0;
  }
  &-login {
    margin-left:auto;
    padding-left:1rem;
    flex-shrink:0;
    .flex();
    align-items:center;
    a {
      padding:.5rem 1rem;
      color: #333;
      &:hover {
        color:#fff;
        background-color:#4776e6;
      }
    }
  }
}
.mobile {
  &-menu-wrap {
    .flex-column();
    flex-grow:1;
    overflow-y:auto;
    background-color:#fff;
  }
  &-menu {
    padding:1rem 0;
    > a {
      display:block;
      padding:.25rem 1rem;
      color:#777;
      &:hover {
        color:#4776e6;
        background-color:#f5f5f5;
      }
    }
  }
  &-submenu {
    padding-top:.5rem;
    .flex();
    flex-wrap:wrap;
    a {
      padding:.25rem 1rem;
      .flex();
      align-items:center;
      align-self: stretch;
      color:#555;
      &:hover, &.active {
        color: #f5f5f5;
        background-color: #4776e6;
        border-radius:.5rem;
      }
    }
  }
  &-login {
    padding:1rem;
    a {
      color:#4776e6;
    }
  }
  &-footer {
    padding:1rem;
    .flex-column();
    align-items:center;
    margin-top:auto;
    flex-shrink:0;
    border-top:1px #eee solid;
    .links {
      a {
        color:#777;
      }
    }
    .infos {
      .flex-center();
      .qrcode {
        margin-left:1rem;
      }
    }
  }
}
.site-container.is-mobile {
  .app-logo-header {
    padding:0;
    align-items: center;
    .site-slogan, .site-logo-date {
      display:none;
    }
    .site-logo-search {
      margin-left:1rem;
      margin-right:.5rem;
      width:80%;
      max-width:50vw;
      /deep/ .el-input__inner {
        padding-left:8px;
        height:2rem;
        .fontsize(.95rem);
        line-height:2rem;
        border-width:1px;
      }
      /deep/ .el-input__suffix {
        right:8px;
      }
      /deep/ .el-input__suffix-inner {
        .fontsize(1rem);
        line-height:2rem;
      }
    }
    .site-logo-logo {
      padding-left:.5rem;
      img {
        height:2.8rem;
      }
    }
  }
  .site-nav{
    min-height:3rem;
    &-box.sub-container {
      padding-left:0;
      padding-right:0;
    }
  }
  .site-logo {
    margin-right:1rem;
    padding:.3rem 0;
    img {
      height:2.4rem;
    }
  }
  .site-nav-menu {
    &-wrap {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
    display:inline-flex;
    a {
      margin:0 1px;
      padding:.25rem .45rem;
      .fontsize(1.1rem);
      border-left:none;
      border-right:none;
    }
  }
  .site-search {
    padding-left:1.1rem;
    padding-right:0;
    .fontsize(1.4rem);
  }
}
/*
@media screen {
  @media (max-width:768px) {
    .site {
      &-bar, &-search {
        .flex-center-v();
      }
      &-bar {
        margin-right:1rem;
      }
      &-search {
        margin-left:auto;
      }
      &-nav-menu-wrap, &-login {
        display:none;
      }
      &-nav-submenu {
        display:none;
      }
    }
    .site-nav-menu{

    }
  }
}
*/
</style>